<template>
  <header :class="{trans: trans}">
    <primary-navigation></primary-navigation>
    <div class="extras">
      <div class="user">{{ $session.user.fullName }}</div>
      <nav-toggle :class="{active: isSecondaryNavActive}" @click.native="isSecondaryNavActive = !isSecondaryNavActive" />
      <transition>
        <secondary-navigation v-if="isSecondaryNavActive" @close="isSecondaryNavActive = false"></secondary-navigation>
      </transition>
    </div>
  </header>
</template>

<script>

  import PrimaryNavigation from "./PrimaryNavigation"
  import SecondaryNavigation from "./SecondaryNavigation"
  import NavToggle from "./NavToggle"

  export default {
    name: 'AppHeader',
    components: { PrimaryNavigation, SecondaryNavigation, NavToggle },
    props: {
      trans: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isSecondaryNavActive: false
      }
    },
    created () {
      this.$router.afterEach(() => {
        this.isSecondaryNavActive = false
      })
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  header {
    @include container;
    @include font-size(small);
    display:flex; max-width:none; align-items:center; justify-content:space-between; height:$header-height; position:relative; z-index:99; box-shadow:0 2px 4px 0 rgba($color-black, .25); background-color:#fff;
    > div {
      display:flex; align-items:center; justify-content:flex-end;
    }
    &.trans {
      background:linear-gradient(rgba(#fff, .6), rgba(#fff, 0)); position:absolute; width:100%; box-shadow:none;
      @include media(large){
        content:'';
        &:before {
          content:''; flex:1;
        }
        > * {
          flex:1;
        }
        > nav {
          flex:2;
        }
        /deep/ .logo {
          margin:0 auto;
          svg {
            width:375px; transform:translateY(2rem);
          }
        }
      }
    }
  }

  button {
    @include button-reset;
    svg {
      width:20px; fill:#000;
    }
  }

  ul {
    &.active + .overlay {
      opacity:1;
    }
  }

  .extras {
    @include hide-for-print;
  }

  .user {
    margin-right:1rem; z-index:6;
    @include media(small,medium) {
      display:none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppHeader/index.vue